export default {
    typeVehicles: [],
    dataVehicle: [],
    showComponentVehicle: false,
    countries: [],
    params_client: {
        is_search_plate: 0,
        only_active: true,
        only_active_api_search: true,
        filter: '',
        type: 'is_customer',
        is_customer: true,
        paginate: false,
        contact_id: null,
        contact_warehouse_id: null,
        with_contact_warehouses: 0
    },
    contacts: [],
    client: null
};



// WEBPACK FOOTER //
// ./src/modules/contact-vehicles/state.js